// extracted by mini-css-extract-plugin
export default {"brand-cobalt":"rgb(64, 36, 211)","useCurrentValueOption":"styles_useCurrentValueOption__mGjV6"};